
import { Box, Button } from '@material-ui/core'
import PropTypes from 'prop-types'

import { getParams } from 'common/click-tracking-params'

/**
 * CreateAccount button links to the signup page (exists outside of the app)
 * @param {Object} props
 * @prop {String} skipNavId
 * @returns CreateAccount Component
 */
const CreateAccount = (props: any) => {
  const params = getParams('Create Account', 'L1')

  return (
    <Box
      whiteSpace="nowrap"
      width={props.fullWidth === true ? '100%' : 'auto'}
    >
      <Button
        {...props}
        component="a"
        variant="contained"
        color="primary"
        size="large"
        href={`${window.location.origin}/signup?${params}`}
        aria-label="Create an account for Scoir"
      >
        Create Account
      </Button>
    </Box>
  )
}

CreateAccount.propTypes = {
  skipNavId: PropTypes.string,
  hasCollegesToCompare: PropTypes.bool,
  location: PropTypes.object,
}

export default CreateAccount
